export default "__VITE_ASSET__D2l1S$iO__"